import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { StyleValue } from 'vue';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'SimpleCard',
  props: {
    customStyle: { type: [Boolean, null, String, Object, Array], default: undefined }
  },
  emits: ["scroll"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const customCardStyle = props.customStyle ?? {};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(_unref(customCardStyle)),
    class: "simple-card",
    onScroll: _cache[0] || (_cache[0] = ($event: any) => (emits('scroll')))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 36))
}
}

})